<template>
    <div class="modal-bg">
        <div v-if="visible" class="modal-overlay" @click.self="handleClickOutside">
            <div class="modal-content" @click.stop :style="modalContentStyle">
                <div class="modal-header">
                    <h2 class="modal-title" v-if="title">{{ title }}</h2>
                    <button v-if="showClose" class="close-modal" @click="closeModal">
                        ✖
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer" v-if="showFooter">
                    <div class="form-actions" v-if="isFormModal">
                        <button
                            v-for="(btn, index) in footerButtons"
                            :key="index"
                            class="btn"
                            :class="btn.type"
                            @click="handleButtonClick(btn.action, index)"
                        >
                            {{ btn.text }}
                        </button>
                    </div>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        showClose: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        isFormModal: {
            type: Boolean,
            default: false
        },
        footerButtons: {
            type: Array,
            default: () => [
                { text: '取消', type: 'btn-secondary', action: 'cancel' },
                { text: '确认', type: 'btn-primary', action: 'confirm' }
            ]
        },
        // 新增背景透明度属性
        overlayOpacity: {
            type: Number,
            default: 0.5
        },
        contentWidth: {
            type: [String, Number],
            default: '90%' // 默认宽度
        }
    },
    computed: {
        modalContentStyle() {
            const width = typeof this.contentWidth === 'number'
                ? `${this.contentWidth}px`
                : this.contentWidth;

            return { width: width,maxWidth: '70vw'};
        }
    },
    methods: {
        openModal() {
            this.visible = true;
            this.$nextTick(() => {
                const modalBg = document.querySelector('.modal-bg');
                modalBg.style.top = '0';
                modalBg.style.left = '0';
                modalBg.style.width = '100vw';
                modalBg.style.height = '100vh';
            });
        },
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        closeModal() {
            this.$emit('update:visible', false);
            this.$emit('close');
        },

        handleButtonClick(action, index) {
            this.$emit('button-click', action, index);
            if (action !== 'keep-open') {
                this.closeModal();
            }
        },

        handleClickOutside() {
            if (this.$props.closeOnClickOutside !== false) {
                this.closeModal();
            }
        }
    }
}
</script>

<style>
.modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background-color: rgba(0, 0, 0, v-bind("overlayOpacity"));
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1; /* 确保在 modal-bg 内部 */
    transition: opacity 0.3s ease;
}

.modal-content {
    background: rgba(20, 35, 70, 0.95);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(0, 255, 150, 0.3);
    border-radius: 16px;
    padding:1rem 1.5rem 1.5rem 1.5rem;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    animation: modalFadeIn 0.3s ease;
    transform: scale(1);
    opacity: 1;
}

@keyframes modalFadeIn {
    from {
        transform: scale(0.9);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 255, 150, 0.2);
    margin-bottom: 1rem;
}

.modal-title {
    font-size: 20px;
    color: #00ff96;
}

.close-modal {
    background: none;
    border: none;
    color: #94a3b8;
    font-size: 20px;
    cursor: pointer;
    transition: color 0.3s ease;
}

.close-modal:hover {
    color: #ff6b6b;
}

.modal-body {
    padding: 0;
}

.modal-footer {
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(0, 255, 150, 0.2);
}

.form-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

.btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.btn-primary {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: #0a0e27;
    font-weight: 600;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
}

.btn-secondary {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.3);
    color: #00ff96;
}

.btn-secondary:hover {
    background: rgba(0, 255, 150, 0.1);
    border-color: #00ff96;
}
</style>